import script from "./OperationLog.vue?vue&type=script&setup=true&lang=js"
export * from "./OperationLog.vue?vue&type=script&setup=true&lang=js"

import "./OperationLog.vue?vue&type=style&index=0&id=dd2877d8&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-dd2877d8"]])

export default __exports__